import * as MutationTypes from './mutationTypes';
import { ForecastDemand, EventOccurrence } from './models';
import * as api from './api';

export const forecastDemandListRequest = async ({ commit }, periodGuid) => {
  const response = await api.forecastDemandListRequest(periodGuid);
  const forecastDemandList = ForecastDemand.toInstanceList(response.data.demand_recommendation_list);
  commit(MutationTypes.FORECAST_DEMAND_LIST_SUCCESS, forecastDemandList);
  return forecastDemandList;
};

export const editForecastDemandList = ({ commit }, payload) => {
  commit(MutationTypes.EDIT_FORECAST_DEMAND, payload);
};

export const saveForecastDemandListRequest = async ({ dispatch, getters: { forecastDemandList } }, periodGuid) => {
  const serializedForecastDemandList = forecastDemandList.map((el) => el.serialize());
  await api.saveForecastDemandListRequest(periodGuid, serializedForecastDemandList);
  await dispatch('validatePeriodDemand', periodGuid);
};

export const eventOccurrenceListRequest = async ({ commit }, periodGuid) => {
  const response = await api.eventOccurrenceListRequest(periodGuid);
  const eventOccurrenceList = EventOccurrence.toInstanceList(response.data.results);
  commit(MutationTypes.EVENT_OCCURRENCE_LIST_SUCCESS, eventOccurrenceList);
  return eventOccurrenceList;
};
